import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

class TextArea extends PureComponent {
  render () {
    const classNames = ['InputTextArea']
    let label
    if (this.props.label !== undefined) {
      label = <label>{this.props.label + (this.props.required ? ' *' : '')}</label>
    }

    let message
    if (this.props.valid !== true) {
      if (this.props.message) {
        message = <span>{this.props.message}</span>
      }
      classNames.push('InputTextAreaError')
    }

    return (
      <div className={classNames.join(' ')}>
        {label} {message}

        <textarea placeholder={this.props.placeholder}
                  onChange={this.props.onChange}
                  onBlur={this.props.onBlur}
                  onFocus={this.props.onFocus}
                  value={this.props.value}
                  name={this.props.name}
                  required={this.props.required}
                  disabled={this.props.disabled}
        />
      </div>
    )
  }
}

TextArea.defaultProps = {
  placeholder: '',
  disabled: false,
  required: false,
  valid: true
}

TextArea.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  valid: PropTypes.bool,
  message: PropTypes.string,
  name: PropTypes.string
}

export default TextArea
